import { render, staticRenderFns } from "./SignupValidate.vue?vue&type=template&id=1afe8c2c&"
import script from "./SignupValidate.vue?vue&type=script&lang=js&"
export * from "./SignupValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports